import React, { FC, useEffect } from 'react'
import { Container, Button, Row, Col } from 'react-bootstrap'
import Card from 'react-bootstrap/Card'
import { connect } from 'react-redux'
import InternalLink from '../../../components/atoms/InternalLink'
import Separator from '../../../components/atoms/Separator'
import AlertBox from '../../../components/molecules/AlertBox'
import text from '../../../_constants/text'
import routes from '../../../router/routes'
import { useServiceNotification } from '../../../hooks/useServiceNotification'
import { analyticsTracker } from '../../../services/analytics/analyticsTrackerService'
import { GAEventNames } from '../../../domain/models/commons/GoogleAnalytics'
import { ssoLogin } from '../../../actions/SSOLoginActions/ssoLoginAction'

type LoginFormProps = {
  hasSessionTimedOut: boolean
  login: () => void
  loginFailure: boolean
  loginError?: string
}

const LoginForm: FC<LoginFormProps> = ({ hasSessionTimedOut, login, loginFailure, loginError }) => {
  const serviceNotification = useServiceNotification()

  useEffect(() => {
    if (loginFailure) {
      analyticsTracker().track(GAEventNames.LOGIN_FAILURE, {})
    }

    if (hasSessionTimedOut) {
      analyticsTracker().track(GAEventNames.SESSION_TIMEOUT, {})
    }
  }, [loginFailure, hasSessionTimedOut])

  return (
    <Card as="section" className="my-3 my-lg-4">
      <Card.Body className="p-3 p-lg-4">
        {serviceNotification?.show && (
          <AlertBox type={serviceNotification.type} message={serviceNotification.message} />
        )}
        <Card.Title as="h2" className="mb-4">
          {text.SIGN_IN}
        </Card.Title>
        {loginFailure && <AlertBox type="error" message={loginError || text.UNEXPECTED_ERROR} />}
        {hasSessionTimedOut && <AlertBox type="warning" message={text.LOGOUT_SESSION_TIMEOUT} />}
        <Container className="d-flex flex-column px-2 px-lg-0 mt-4">
          <Row className="mb-2 justify-content-center">
            <Col xs={12} sm={10} md={8}>
              <Button data-testid="login-button" className="w-100 px-4 py-2" onClick={login}>
                {text.SSO_SIGN_IN}
              </Button>
            </Col>
          </Row>
          <Row>
            <Separator />
            <InternalLink href={routes.apply} className="pt-4">
              {text.SSO_CREATE_ACCOUNT}
            </InternalLink>
          </Row>
        </Container>
      </Card.Body>
    </Card>
  )
}

const mapStateToProps = (state) => {
  const { submit, hasSessionTimedOut, error } = state.login
  return { hasSessionTimedOut, loginFailure: submit.fail, loginError: error }
}

const mapDispatchToProps = (dispatch) => ({
  login: () => dispatch(ssoLogin()),
})

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm)
